/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Policies and permissions the role posses.
 */
export interface AccountRolePermissions { 
    /**
     * Permission boundary set on the role.
     */
    permissions_boundary?: string;
    /**
     * list of policies the role has.
     */
    policies?: Array<string>;
    trust_relationships?: string;
}

